import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.03 4.565a4.874 4.874 0 00-5.464 5.47 4.909 4.909 0 004.148 4.18 5.015 5.015 0 001.808-.083l.349 1.507a6.56 6.56 0 01-2.37.109l-.007-.001a6.456 6.456 0 01-5.461-5.5v-.005a6.422 6.422 0 017.2-7.211h.004a6.448 6.448 0 015.511 5.472v.003a6.413 6.413 0 01-1.661 5.262 1.37 1.37 0 00.065 1.891l.007.007.762.762h2.188v2.189l.849.848h1.508v-1.509l-4.059-4.059 1.094-1.094 4.513 4.512v3.697h-3.697l-1.755-1.754v-1.282H14.28l-1.212-1.213a2.917 2.917 0 01-.127-4.035l.005-.005.005-.006a4.867 4.867 0 001.265-3.996 4.9 4.9 0 00-4.186-4.156z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.25 8.75a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-1.5 0a1 1 0 11-2 0 1 1 0 012 0z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.03 4.565a4.874 4.874 0 00-5.464 5.47 4.909 4.909 0 004.148 4.18 5.015 5.015 0 001.808-.083l.349 1.507a6.56 6.56 0 01-2.37.109l-.007-.001a6.456 6.456 0 01-5.461-5.5v-.005a6.422 6.422 0 017.2-7.211h.004a6.448 6.448 0 015.511 5.472v.003a6.413 6.413 0 01-1.661 5.262 1.37 1.37 0 00.065 1.891l.007.007.762.762h2.188v2.189l.849.848h1.508v-1.509l-4.059-4.059 1.094-1.094 4.513 4.512v3.697h-3.697l-1.755-1.754v-1.282H14.28l-1.212-1.213a2.917 2.917 0 01-.127-4.035l.005-.005.005-.006a4.867 4.867 0 001.265-3.996 4.9 4.9 0 00-4.186-4.156z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.25 8.75a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-1.5 0a1 1 0 11-2 0 1 1 0 012 0z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.06 9.13A9.749 9.749 0 009.13 20.071a9.819 9.819 0 008.297 8.358c1.205.165 2.43.108 3.616-.166l.697 3.015a13.12 13.12 0 01-4.74.216l-.014-.002a12.912 12.912 0 01-10.922-11l-.001-.01a12.843 12.843 0 0114.403-14.42h.008a12.896 12.896 0 0111.022 10.944v.006a12.826 12.826 0 01-3.323 10.525 2.738 2.738 0 00.13 3.782l.007.007 1.532 1.531h4.376v4.377l1.697 1.696h3.017v-3.017l-8.118-8.119 2.188-2.188 9.025 9.025v7.394h-7.394l-3.51-3.51v-2.563H28.56l-2.425-2.426a5.833 5.833 0 01-.253-8.07l.01-.01.01-.01a9.731 9.731 0 002.53-7.993A9.8 9.8 0 0020.06 9.13z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17.5a5 5 0 11-10 0 5 5 0 0110 0zm-3 0a2 2 0 11-4 0 2 2 0 014 0z",
    clipRule: "evenodd"
  }))
};
export var FirstAccess = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});